@use "../scss/var.scss" as *;

.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 260px;
  background: $white;
  border-right: 1px solid $color_disabled;
  height: 100dvh;
  position: relative;
  overflow: hidden;

  .sidebar-show {
    margin-right: auto;
  }

  &.hide {
    display: none !important;

    .sidebar-show {
      display: none;
    }

    .sidebar-bottom .sidebar-btn .material-icons,
    .sidebar-menu .sidebar-btn .material-icons {
      margin-right: 3px;
    }
  }

  .sidebar-logo {
    a {
      display: flex;
      align-items: center;

      .sidebar-logo-img {
        width: 150px;
        height: 23px;
        padding: 5px;
      }

      .logo-wrapper {
        display: flex;
        align-items: center;
        padding: 16px;

        .logo-text {
          margin-left: 10px;
          padding-left: 10px;
          color: #8f9091;
          font-family: "SF Pro Display";
          @include fontCaption3;
          line-height: 11px;
          border-left: 1px solid $color_disabled;
          max-width: 70px;
        }
      }
    }
  }

  // `auto`, NOT `scroll`. `scroll` shows the scrollbar track unconditionally, so all
  // three of these blocks carried a permanent gutter — most visibly `.sidebar-bottom`,
  // which holds the user badge and one row of controls and therefore never has
  // anything to scroll. `auto` shows a scrollbar only when there is overflow, which is
  // the whole of the intended behaviour; `.sidebar-scrollable` below already used it.
  .sidebar-menu,
  .sidebar-bottom,
  .sidebar-pinned {
    display: flex;
    flex-direction: column;
    padding: 5px;
    gap: 2px;
    overflow-y: auto;
  }

  .sidebar-scrollable {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .sidebar-pinned {
    padding: 10px 5px 5px 5px;

    .sidebar-pinned-title {
      color: $color_description;
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 8px;
      letter-spacing: 0.5px;
      margin-left: 10px;
      margin-top: 5px;
    }
  }

  .sidebar-delimiter {
    height: 1px;
    background: $color_disabled;
    margin: 0 15px;
  }

  .sidebar-btn {
    padding: 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    color: $color_text;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    border: 1.5px solid transparent;
    background: none;
    gap: 8px;
    transition:
      color 0.2s,
      background 0.2s,
      border 0.2s;

    .pin-icon {
      font-size: 18px;
      color: $color_placeholder;
      // margin-left: auto;
      transition: color 0.2s;

      &.pinned {
        color: $blue !important;

        &:hover {
          color: $light_blue !important;
        }
      }

      &:hover {
        color: $color_description !important;
      }
    }

    &:hover {
      color: $blue;
      border: 1.5px solid $light_blue_10;
    }

    &.active:not(.not-active) {
      color: $blue;
      border: 1.5px solid $light_blue;
    }

    .right-btn {
      margin-left: auto;
      min-width: 24px;
      text-align: center;
    }
  }

  .sidebar-bottom {
    flex-direction: row;
    align-items: center;
    gap: 10px;

    .sidebar-bottom-left .user-badge {
      background: $light_blue;
      color: $white;
      @include fontCaption2;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      cursor: pointer;
      overflow: hidden;

      .user-badge-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
    }

    .sidebar-bottom-right {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;

      .sidebar-bottom-user {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .sidebar-bottom-name {
        @include fontCaption2;
      }

      .sidebar-bottom-role {
        @include fontCaption3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: fit-content;
        max-width: 100%;

        &.has-more {
          cursor: default;
        }
      }

      .sidebar-bottom-email {
        @include fontCaption3;
        color: $color_description;
      }
    }
  }

  .btn-sidebar-hide,
  .btn-sidebar-show {
    display: none;
    position: absolute;
    z-index: 4;
    padding: 0;
    border-radius: 10px 0 0 10px;
  }

  .btn-sidebar-hide {
    right: -3px;
    bottom: 100px;
  }

  .btn-sidebar-show {
    left: 0;
    bottom: 100px;
    border-radius: 0 10px 10px 0;
  }

  &.show:hover .btn-sidebar-hide,
  &.hide:hover .btn-sidebar-show {
    display: block;
  }

  & {
    overflow-y: auto;
  }

  .btn-sidebar-mobile {
    display: none;
    color: $color_text;
    background: none;
    border: none;
    padding: 8px;
    margin-left: 8px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }

  .btn-sidebar-mobile-close {
    display: none;
    position: absolute;
    top: 10px;
    right: 16px;
    background: none;
    border: none;
    z-index: 101;
    font-size: 28px;
    cursor: pointer;
  }

  .sidebar-app-switch {
    padding: 4px 5px;

    .sidebar-app-switch-link {
      width: 100%;
      height: auto;
      padding: 6px 8px;
      background: none;
      border: 1px solid transparent;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: $color_description;
      cursor: pointer;

      .material-icons {
        font-size: 18px;
      }

      .sidebar-app-switch-caret {
        margin-left: auto;
      }

      &:hover,
      &.open {
        color: $blue;
        border-color: $light_blue_10;
      }
    }
  }
}

.sidebar-app-switch-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;

  .sidebar-app-switch-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 6px;
    font-size: 14px;
    color: $color_text;
    text-decoration: none;
    white-space: nowrap;

    .material-icons {
      font-size: 16px;
      margin-left: auto;
      color: $color_placeholder;
    }

    &:hover {
      background: $light_blue_10;
      color: $blue;

      .material-icons {
        color: $blue;
      }
    }
  }
}

// POPOVER
.sidebar-popover {
  position: fixed;
  min-width: 220px;
  background: $white;
  border-radius: 10px;
  box-shadow:
    0 4px 16px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.03);
  z-index: 9998;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px;

  .sidebar-show {
    margin-right: auto;
  }

  // All roles, listed when the account menu's role line has more than one.
  .sidebar-roles-popover {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .sidebar-role-item {
      padding: 6px 8px;
      border-radius: 6px;
      font-size: 14px;
      color: $color_text;
      white-space: nowrap;
    }
  }

  > .sidebar-btn {
    padding: 10px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: $color_text;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    border: 1px solid transparent;
    background: none;
    gap: 8px;
    transition:
      color 0.2s,
      background 0.2s,
      border 0.2s;

    .material-icons-outlined,
    .material-symbols-outlined,
    .material-icons,
    svg {
      margin-right: 10px;
    }

    .right-btn {
      margin-left: auto;
      margin-right: 0px;
    }

    .pin-icon {
      font-size: 18px;
      color: $color_placeholder;
      // margin-left: auto;
      transition: color 0.2s;

      &.pinned {
        color: $blue !important;

        &:hover {
          color: $light_blue !important;
        }
      }

      &:hover {
        color: $color_description !important;
      }
    }

    &:hover {
      color: $blue;
      border: 1px solid $light_blue_10;
    }

    &.active:not(.not-active) {
      color: $blue;
      border: 1.5px solid $light_blue;
    }
  }
}

// Show mobile menu button only on small screens
@media (max-width: $tablet_size) {
  .sidebar {
    .btn-sidebar-mobile {
      display: flex;
    }
    .btn-sidebar-mobile-close {
      display: block;
    }
  }
}

.sidebar-submenu {
  padding-left: 32px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
}
